/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{--color:#0080ff;--size:48px;--coefficient:0.1042;--min-border-width:2px;width:var(--size);height:var(--size);border:calc(max(var(--size) * var(--coefficient), var(--min-border-width))) solid var(--color);border-bottom-color:transparent;border-radius:50%;display:inline-block;box-sizing:border-box;-webkit-animation:rotation 1s linear infinite;animation:rotation 1s linear infinite}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}"];
export { styles as styles };
//# sourceMappingURL=spinner.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/spinner/spinner.component.scss.shim.ngstyle.js
// module id = 1314
// module chunks = 27 28 29